const NProgress = require("nprogress");

// позволяет обновить список конкурсов по страницам
// пагинация от datatables
function updateContestsPage() {
  const nextButton = document.querySelector("button.dt-paging-button.next");
  nextButton?.click();
  const firstButton = document.querySelector("button.dt-paging-button.first");
  firstButton?.click();
}

function initGalleryFilter() {
  const progressSelector = ".js-gallery-filter-progress";

  const form = document.querySelector(".js-gallery-filter-form");
  const content = document.querySelector(".js-gallery-filter-content");
  const progress = document.querySelector(progressSelector);
  const searchInput = document.querySelector(
    'input#search-input[data-search-group="contests"]'
  );

  function insertAttributes() {
    searchInput.value = "";
    const titles = document.querySelectorAll(".block-filter-title");
    titles[1]?.setAttribute("data-search-group", "contests");
    titles[1]?.setAttribute(
      "data-search-counter",
      "конкурс,конкурса,конкурсов"
    );

    const hideElements = [
      titles[0],
      document.querySelector(".spacer-after-title"),
      document.querySelector(".block-contests-top"),
    ];
    hideElements.forEach((element) => {
      element?.setAttribute("data-search-group", "contests");
      element?.setAttribute("data-search-hide", "grid");
    });

    document.querySelectorAll(".block-contests-all-card").forEach((element) => {
      element.setAttribute("data-search-group", "contests");
      const cardTitle = element.querySelector(
        ".block-contests-card-title a"
      ).innerHTML;
      element.setAttribute("data-search-value", cardTitle);
    });
  }

  if (!form || !content || !progress) return;

  NProgress.configure({
    parent: progressSelector,
    showSpinner: false,
  });

  form.addEventListener("change", async (e) => {
    e.preventDefault();

    const formData = new FormData(form);
    let queryStr = new URLSearchParams(formData).toString();

    let url = queryStr
      ? `${form.getAttribute("action")}?${queryStr}`
      : `${form.getAttribute("action")}`;

    NProgress.start();

    const response = await fetch(url, {
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    });

    const data = await response.json();

    content.innerHTML = data.html;

    history.pushState({}, document.title, url);

    NProgress.done();

    // если параметры фильтров пустые
    if (!queryStr) {
      const dt = document.querySelector(
        "#contestsTable_wrapper.dt-container.dt-empty-footer"
      );
      if (dt) {
        dt.classList.remove("hidden");
      }
      // добавляем пагинацию
      updateContestsPage();
    } else {
      // убираем видимость пагинации
      const dt = document.querySelector(
        "#contestsTable_wrapper.dt-container.dt-empty-footer"
      );
      if (dt) {
        dt.classList.add("hidden");
      }
    }

    insertAttributes();
  });
}

export { initGalleryFilter };
